/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
import React, { useContext } from 'react';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import { ActionIcon } from '@mummssoftware/common-ui';
import {
  VFGlobalContext,
  ADD_EDITING_DATA,
} from '@mummssoftware/global-context/VFGlobalContext';
import { OrdersGlobalContext } from '@mummssoftware/global-context';
import { CPFContext } from '../../containers/Context/CPFContext';
import {
  SET_EDIT_ROW_OPEN,
  SET_AG_ROW_EDTING_DATA,
} from '../../containers/Context/constants';
import {
  getWidgetEditMode,
  shouldHideOrderAddIcon,
  shouldShowPencilColumn,
} from '../../editPolicy';
import { getPrimaryFrequencyPlan } from '../../utils/orderRows';
import { createOrderEntryId } from './orderEntryHelpers';
import { hasEndDate } from './utils';

export const EditRowCell = (props: any) => {
  const { data, rgHash } = props;
  const {
    roleGroupId,
    name,
    id,
    isOrderBaseline,
    isOrderPending,
    isNewestOrderPending,
    isOrderAddTarget,
  } = data;

  const { isCPFAgency, isPRNOrderAgency, dispatch } = useContext(CPFContext);
  const { VFordersMode, dispatchVF } = useContext(VFGlobalContext);
  const { orderType } = useContext(OrdersGlobalContext);

  const mode = getWidgetEditMode({
    isCPFAgency: !!isCPFAgency,
    isPRNOrderAgency: !!isPRNOrderAgency,
    VFordersMode,
  });
  // Pencil / + is Way 1 (order) only — Way 2 uses double-click + OptionsCell.
  const displayEdit = shouldShowPencilColumn(mode);
  const showEditGear = isCPFAgency || isPRNOrderAgency;
  const hideAdd = shouldHideOrderAddIcon({
    roleGroupId,
    isPRNOrderAgency: !!isPRNOrderAgency,
    VFordersMode,
    orderType,
  });

  const openDialog = (rowData: any) => {
    dispatch({
      type: SET_AG_ROW_EDTING_DATA,
      payload: { ...props, data: rowData },
    });
    dispatch({
      type: SET_EDIT_ROW_OPEN,
      payload: true,
    });
  };

  const onAddNewEntry = () => {
    const entryId = createOrderEntryId(roleGroupId);
    dispatchVF({
      type: ADD_EDITING_DATA,
      payload: {
        entryId,
        id: roleGroupId,
        name,
        createdAt: Date.now(),
        orderType,
      },
    });
    openDialog({
      ...data,
      orderEntryId: entryId,
      isOrderPending: true,
      isNewestOrderPending: true,
      isOrderAddTarget: false,
      isOrderBaseline: false,
      id: `pending-${entryId}`,
    });
  };

  const onEditPendingEntry = () => {
    openDialog(data);
  };

  const onEditBaseline = () => {
    const basePlan = getPrimaryFrequencyPlan(rgHash, roleGroupId);
    const entryId = createOrderEntryId(roleGroupId);
    dispatchVF({
      type: ADD_EDITING_DATA,
      payload: {
        entryId,
        id: roleGroupId,
        name,
        createdAt: Date.now(),
        orderType,
        rowType: 'baseline-edit',
        sourcePlanId: basePlan?.id,
        sourceEffectiveDate: basePlan?.effectiveDate,
        period: basePlan?.period,
        frequency: basePlan?.frequency,
        daysOfWeek: basePlan?.daysOfWeek,
        prn: basePlan?.prn,
        effectiveDate: basePlan?.effectiveDate,
      },
    });
    openDialog({
      ...data,
      orderEntryId: entryId,
      isOrderPending: true,
      isNewestOrderPending: true,
      isOrderAddTarget: false,
      isOrderBaseline: false,
      id: `pending-${entryId}`,
    });
  };

  // + = stage a NEW pending row (baseline / add-target / add-another).
  // Edit = change an existing pending row in place.
  let RowActionIcon = EditIcon;
  let onClick = onEditPendingEntry;
  if (isOrderBaseline) {
    RowActionIcon = AddIcon;
    onClick = onEditBaseline;
  } else if (isOrderPending && isNewestOrderPending) {
    RowActionIcon = AddIcon;
    onClick = onAddNewEntry;
  } else if (isOrderPending) {
    RowActionIcon = EditIcon;
    onClick = onEditPendingEntry;
  } else if (isOrderAddTarget) {
    RowActionIcon = AddIcon;
    onClick = onAddNewEntry;
  } else {
    RowActionIcon = EditIcon;
    onClick = onEditBaseline;
  }

  const roleGroup = rgHash[roleGroupId.toString()];
  const frequencyPlan =
    roleGroup?.frequencies?.[id] || roleGroup?.frequencies?.dummy;
  // Non-order: do not edit closed plans. Orders mode + stages a new entry (master).
  if (hasEndDate(frequencyPlan) && !VFordersMode) {
    return null;
  }

  if (roleGroup && displayEdit && showEditGear) {
    if (VFordersMode && isOrderPending && isNewestOrderPending) {
      return (
        <div style={{ display: 'flex' }}>
          {!hideAdd && (
            <ActionIcon
              style={{ margin: '0px' }}
              Icon={AddIcon}
              onClick={onAddNewEntry}
            />
          )}
          <ActionIcon
            style={{ margin: '0px' }}
            Icon={EditIcon}
            onClick={onEditPendingEntry}
          />
        </div>
      );
    }
    if (hideAdd && RowActionIcon === AddIcon) {
      return null;
    }
    return (
      <div>
        <ActionIcon
          style={{ margin: '0px' }}
          Icon={RowActionIcon}
          onClick={onClick}
        />
      </div>
    );
  }
  return null;
};

export default EditRowCell;
